<template>
	<v-list class="bookmarks-list">
		<div class="bookmark-empty" v-if="bookmarks.length === 0">
			<span class="bookmark-empty__text"> No Bookmarks Available </span>
		</div>
		<div v-for="(bookmark, index) in bookmarks" :key="index">
			<div
				@click="handleToggle(bookmark.bookmark_entity_type)"
				class="bookmarks-list__item u-cursor-pointer"
			>
				<span class="bookmarks-list__item__title">
					{{ bookmark.label }}
				</span>
				<Icon type="chevron_right" :size="14" />
			</div>
		</div>
	</v-list>
</template>

<script>
import Dwh from '@/mixins/Dwh'
export default {
	name: 'BookmarkList',
	mixins: [Dwh],
	props: {
		bookmarks: {
			type: Array,
			default: () => [],
		},
		currentUser: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			dwhMap: {
				Speakers: {
					action: 'click_bookmark_tab_speakers',
					title: 'Speakers',
				},
				Partners: {
					action: 'click_bookmark_tab_exhibitors',
					title: 'Exhibitors',
				},
				Threads: {
					action: 'click_bookmark_tab_news',
					title: 'News Feed',
				},
				Events: {
					action: 'click_bookmark_tab_events',
					title: 'Events',
				},
				Discussions: {
					action: 'click_bookmark_tab_discussions',
					title: 'Discussions',
				},
			},
		}
	},
	methods: {
		dwhClickHandler(action, source) {
			this.sendTrigger({
				category: 'Bookmarks',
				action: action,
				module: 'My Account',
				title: source,
				id1: this.currentUser.user_id,
			})
		},
		handleToggle(source) {
			const dwhData = this.dwhMap[source]

			if (dwhData) {
				this.dwhClickHandler(dwhData.action, dwhData.title)
			}
			if (source === 'Discussions') {
				this.$router.push({
					name: 'bookmark-list',
					query: {
						source: 'Threads',
						thread_type: 2,
					},
				})
			} else {
				this.$router.push({
					name: 'bookmark-list',
					query: {
						source,
					},
				})
			}
		},
	},
}
</script>

<style lang="scss">
.bookmarks-list {
	background-color: transparent !important;
	display: flex;
	flex-direction: column;
	gap: 8px;
	&__item {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px;
		height: 48px;
		background-color: #ffffff;
		border-radius: 8px;
		border: 1px solid #e2e2e2;
		&__title {
			font-family: Inter, sans-serif;
			font-weight: 500;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			color: #4a4a4a;
		}
	}
}
.bookmark-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 730px;
	&__text {
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: center;
		color: #4a4a4a;
	}
}
</style>
